module.exports = __webpack_public_path__ + "img/powerbank2.44527434.jpg";